import { defineMessages } from "react-intl";

export const exchangeOnlineWizardMessages = defineMessages({
  channelName: {
    defaultMessage: "Add Exchange Online Communication Channel",
    id: "exchangeOnlineWizardMessages.channelName",
  },

  channelFieldName: {
    defaultMessage: "Channel Name",
    id: "exchangeOnlineWizardMessages.channelFieldName",
  },

  changeCredTitle: {
    defaultMessage: "Change credential",
    id: "exchangeOnlineWizardMessages.changeCredTitle",
  },

  changeCredential: {
    defaultMessage: "Credential changed to user account",
    id: "exchangeOnlineWizardMessages.changeCredential",
  },

  description: {
    defaultMessage: "Description",
    id: "exchangeOnlineWizardMessages.description",
  },

  userAccount: {
    defaultMessage: "User account",
    id: "exchangeOnlineWizardMessages.userAccount",
  },

  mailSender: {
    defaultMessage: "Mail sender",
    id: "teamsWizardMessages.mailSender",
  },

  mailRecipients: {
    defaultMessage: "Mail recipients",
    id: "teamsWizardMessages.mailRecipients",
  },
});
